import { useState, useEffect } from "react";
import type { InsuranceOption } from "@/interface/Generali";

/**
 * Fetcha le tariffe assicurative Generali per un articolo e provincia.
 * Ritorna vuoto se enabled === false.
 */
export const useGeneraliRates = (
    codiceArticolo: string,
    provincia: string,
    enabled: boolean
): { options: InsuranceOption[]; isLoading: boolean } => {
    const [options, setOptions] = useState<InsuranceOption[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (!enabled || !codiceArticolo) {
            setOptions([]);
            return;
        }

        let cancelled = false;

        const fetchRates = async () => {
            setIsLoading(true);
            try {
                const res = await fetch(
                    `${process.env.NEXT_PUBLIC_API_URL}/api/order/generali?codiceArticolo=${codiceArticolo}&provincia=${provincia}`
                );
                const data = await res.json();
                const fetched: InsuranceOption[] = data?.assicurazione?.opzioni || [];
                const valid = fetched.filter((o) => parseFloat(o.importo) > 0);
                if (!cancelled) setOptions(valid);
            } catch (error) {
                console.error("Failed to fetch Generali rates:", error);
                if (!cancelled) setOptions([]);
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };

        fetchRates();

        return () => { cancelled = true; };
    }, [codiceArticolo, provincia, enabled]);

    return { options, isLoading };
};
